import { Injectable, EventEmitter } from '@angular/core';

export class HintModel {
  defaultHintText: string;
  hintText: string;
  hintExample: string;
  isHintDefault: boolean;
  hintSubtitle?: string;
}

@Injectable()
export class HintsService {

  model: HintModel = {
    defaultHintText: 'Select a Field or Value to see Hints',
    hintText: '',
    hintExample: '',
    isHintDefault: true,
    hintSubtitle: ''
  };

  showHintEvent: EventEmitter<any> = new EventEmitter<any>();

  public setHintText(obj: { hintText: string, hintExample: string, isHintDefault?: boolean, hintSubtitle?: string }): void {
    Object.assign(this.model, obj);
    this.model.isHintDefault = !!obj.isHintDefault;
    this._emit();
  }

  public resetHint(): void {
    this.setHintText({
      hintText: this.model.defaultHintText,
      hintExample: '',
      isHintDefault: true,
      hintSubtitle: '',
    });
  }

  public setDefaultHintText(htmlOrText: string): void {
    this.model.defaultHintText = htmlOrText;
    this.model.hintText = '';
    this._emit();
  }

  private _emit(): void {
    this.showHintEvent.emit(this.model);
  }

}
